import { render, staticRenderFns } from "./CommunicationDetail.vue?vue&type=template&id=1f674acc&scoped=true&"
import script from "./CommunicationDetail.vue?vue&type=script&lang=js&"
export * from "./CommunicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationDetail.vue?vue&type=style&index=0&id=1f674acc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f674acc",
  null
  
)

export default component.exports